import React from "react";
import { useLocation } from "react-router-dom";
import CadRmsDetailInfo from "../../components/Detail/_CadRmsDetailInfo";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}


function CadRmsDetail() {
    let query = useQuery();

    return (
        <div>
            <CadRmsDetailInfo ID={query.get("ID")} department={query.get("Dept")} />
        </div>
    );
}

export default CadRmsDetail;